
<template>
  <div>
    <el-radio-group v-model="selectValue">
      <el-radio
        v-for="item in checkBoxList"
        :key="item.label"
        :label="item.value"
        @change="changeList"
        >{{ item.label }}</el-radio
      >
    </el-radio-group>
    <span class="custom-checkBox" v-if="selectValue && selectValue.length < 1">
      <CustomNumInput
        :value="capacityUnitStart"
        :maxlength="15"
        :limitNum="0"
        @change-emit="val => (capacityUnitStart = val)"
      />
      <i>-</i>
      <CustomNumInput
        :value="capacityUnitEnd"
        :maxlength="15"
        :limitNum="0"
        @change-emit="val => (capacityUnitEnd = val)"
      /> g/ml
      <el-button
        style="margin-left: 10px"
        type="text"
        size="mini"
        @click="onSearch"
        >查询</el-button
      >
      <el-button type="text" size="mini" @click="resetFn">清空</el-button>
    </span>
    <el-button
      class="reset-radio"
      v-else
      size="mini"
      type="text"
      @click="onReset"
      >清空</el-button
    >
  </div>
</template>
<script>
import CustomNumInput from '@/components/CustomNumInput';
export default {
  name: 'CapacityCheckBox',
  components: {
    CustomNumInput,
  },
  props: {},
  data() {
    return {
      name: 'bcrlActiveName',
      checkBoxList: [
        { label: '30g/ml以下', value: [undefined, 30] },
        { label: '30-50g/ml', value: [30, 50] },
        { label: '50-100g/ml', value: [50, 100] },
        { label: '100-150g/ml', value: [100, 150] },
        { label: '150g/ml以上', value: [150, undefined] },
        { label: '自定义', value: [] },
      ],
      value: [],
      selectValue: '',
      capacityUnit: [],
      capacityUnitStart: '',
      capacityUnitEnd: '',
    };
  },
  methods: {
    changeList(val) {
      if (val.length < 1) {
        this.capacityUnitStart = '';
        this.capacityUnitEnd = '';
      } else {
        this.value = val;
        this.$emit('change-list', this.value, this.name);
      }
    },
    onSearch() {
      this.value = [this.capacityUnitStart, this.capacityUnitEnd];
      this.$emit('change-list', this.value, this.name);
    },
    resetFn() {
      this.value = [];
      this.capacityUnitStart = '';
      this.capacityUnitEnd = '';
      this.$emit('change-list', this.value, this.name);
    },
    onReset() {
      this.selectValue = '';
      this.value = [];
      this.capacityUnitStart = '';
      this.capacityUnitEnd = '';
      this.$emit('change-list', this.value, this.name);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .custom-checkBox {
  position: absolute;
  right: -220px;
  top: -5px;
  line-height: 19px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  display: flex;
  align-items: center;
  b {
    display: inline-block;
    width: 45px;
    font-weight: normal;
  }
  i {
    margin: 0 5px;
  }
  .el-input,
  .el-input__inner {
    width: 60px;
  }
}
/deep/ .el-radio {
  margin-right: 15px;
  .el-radio__label {
    padding-left: 5px;
  }
}

.reset-radio {
  position: absolute;
  right: -70px;
  top: -7px;
  font-size: 14px;
}
</style>